import { FC } from 'react';
import supplierCreated from '../../../assets/supplierCreated.svg';

export const PreferencesSubmittedSuccess: FC = () => (
    <div className="SupplierCompanyPitches__success success">
        <div className="success__block">
            {' '}
            <div className="preferences-submitted">
                <h1 className="preferences-submitted__title">
                    Preferences Submitted <br />
                    Successfully
                </h1>

                <p className="preferences-submitted__text">Thank you. Your availability has been recorded.</p>

                <p className="preferences-submitted__text">
                    Pitch slots will be allocated automatically based on submission order and availability.
                </p>

                <div className="preferences-submitted__section">
                    <p className="preferences-submitted__subtitle">What happens next:</p>

                    <ul className="preferences-submitted__list">
                        <li>Your pitch slot will be assigned automatically.</li>
                        <li>You will receive email confirmation once your slot is confirmed.</li>
                        <li>If required, you may request an alternative slot via the confirmation email.</li>
                    </ul>
                </div>

                <div className="preferences-submitted__contact">
                    <p className="preferences-submitted__text">
                        If you have any questions, please contact the support team at{' '}
                        <a href="mailto:support@askproco.com" className="preferences-submitted__link">
                            support@askproco.com
                        </a>
                    </p>

                    <p className="preferences-submitted__text">
                        or contact us directly at{' '}
                        <span className="preferences-submitted__phone">+27 (0) 21 565 0401</span>
                    </p>
                </div>
            </div>
        </div>
        <img src={supplierCreated} className="image__item" />
    </div>
);
